export const statuses = [
  'PAID',
  'DRAFT',
  'QUOTE',
  'UNPAID',
  'PENDING',
  'PARTIAL',
  'OVERPAID',
  'CANCELLED',
  'UNPAIDINPROGRESS',
  'VOID',
];

export const sources = [
  {
    value: 'vehicle_group',
    source: 'OwnerVehicleGroup',
    label: 'OwnerVehicleGroup',
  },
  {
    value: 'vehicle',
    label: 'Vehicle',
    source: 'Vehicle',
  },
];

export const types = ['billing', 'invoice'];
